const imageContext = require.context(
  './Images',
  true,
  /\.(jpe?g|png|webp)$/i
);

const excludedFolders = new Set(['Projects']);
const featuredImages = {
  Oyin: 'oyin-1.jpg',
  Moya: 'moya-3.jpg',
  Grace: 'grace-1.jpg',
  Mary: 'mary-1.jpg',
  Nyla: 'nyla-3.jpg',
  Joyce: 'joyce-1.jpg',
};

const slugify = value =>
  value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const sortImages = (a, b) =>
  a.name.localeCompare(b.name, undefined, {
    numeric: true,
    sensitivity: 'base',
  });

const galleryMap = imageContext.keys().reduce((items, key) => {
  const [, folder, fileName] = key.match(/^\.\/([^/]+)\/(.+)$/) || [];

  if (!folder || !fileName || excludedFolders.has(folder)) {
    return items;
  }

  if (!items[folder]) {
    items[folder] = {
      folder,
      slug: slugify(folder),
      images: [],
    };
  }

  items[folder].images.push({
    name: fileName,
    src: imageContext(key),
  });

  return items;
}, {});

export const galleries = Object.values(galleryMap)
  .map(gallery => {
    const images = gallery.images.sort(sortImages);
    const featuredImage =
      images.find(image => image.name === featuredImages[gallery.folder]) ||
      images[0];

    return {
      ...gallery,
      images,
      featuredImage,
    };
  })
  .sort((a, b) => a.folder.localeCompare(b.folder));

export const galleriesBySlug = galleries.reduce((items, gallery) => {
  items[gallery.slug] = gallery;
  return items;
}, {});
